import { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteContext } from '../context/RouteContext';

export const MiddleRoute = ({ children }) => {
	const { convo } = useContext(RouteContext);
	console.log(convo);

	//	useEffect(() => {}, [data]);

	return convo > 0 ? children : <Navigate to="/auth/signup" />;
};
